// These formats match EvrakController. No multipart header is set manually:
// the browser must supply its boundary. No background/automatic upload retry.
export const DOCUMENT_UPLOAD_TIMEOUT = 180000;
export const DOCUMENT_ACCEPT = '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';

export function validateDocument(file) {
  if (!file) return 'uploadSelectFile';
  if (!file.size) return 'uploadEmpty';
  if (!/\.(pdf|jpe?g|png)$/i.test(file.name || '')) return 'uploadType';
  // Some phones do not provide a MIME type. Leave final validation to the API.
  if (file.type && !['application/pdf', 'image/jpeg', 'image/png'].includes(file.type.toLowerCase())) return 'uploadType';
  return null;
}

export function documentUploadError(error, online = true, reason = '') {
  const status = Number(error?.response?.status || 0);
  if (status === 401) return {key:'uploadSession', uncertain:false};
  if (status === 403) return {key:'uploadForbidden', uncertain:false};
  if (status === 404) return {key:'uploadMissing', uncertain:false};
  if (status === 413) return {key:'uploadSize', uncertain:false};
  if (status === 415) return {key:'uploadType', uncertain:false};
  if (status === 429) return {key:'uploadBusy', uncertain:false};
  if (status === 400) {
    const data = error.response.data;
    const message = typeof data === 'string' ? data : data?.message || '';
    if (/MIME|uzantı|uzantisi|desteklenmeyen/i.test(message)) return {key:'uploadType', uncertain:false};
    if (/boştur|boş dosya|gönderilmedi/i.test(message)) return {key:'uploadEmpty', uncertain:false};
    if (/değişiklik yapılamaz/i.test(message)) return {key:'uploadApproved', uncertain:false};
    return {key:'uploadRejected', uncertain:false};
  }
  // An error after sending the file does not prove that the server did not save it.
  if (status === 499) return {key:'uploadCancelled', uncertain:true};
  if (status === 408 || status === 504) return {key:'uploadTimeout', uncertain:true};
  if (status >= 500) return {key:'uploadServer', uncertain:true};
  if (status) return {key:'uploadRejected', uncertain:false};
  if (reason === 'offline' || !online) return {key:'uploadConnectionLost', uncertain:true};
  if (reason === 'cancelled') return {key:'uploadCancelled', uncertain:true};
  if (['ECONNABORTED', 'ETIMEDOUT'].includes(error?.code)) return {key:'uploadTimeout', uncertain:true};
  return {key:'uploadConnectionLost', uncertain:true};
}

export function uploadProgress(event) {
  if (!event?.total || !Number.isFinite(event.loaded)) return null;
  return Math.max(0, Math.min(100, Math.round(event.loaded / event.total * 100)));
}

export function hasNewDocumentFile(before, after) {
  return !!after?.url && after.url !== before?.url &&
    ['Yüklendi', 'Onaylandi'].includes(after.durum);
}
